import { useEffect, useState } from "react";
import axios from 'axios';
import { useAuth } from "../../../context/AuthContext";
import { useNavigate, Link, useParams } from "react-router-dom";
import AlertMessage from "../../include/AlertMessage";
var _ = require('lodash');

function AddEventbooking() {
    const { eid } = useParams();
    const { role, user, logout } = useAuth();
    const [formData, setFormData] = useState({
        paymentID: null,
        paymentGateway: 'cash',
        paymentStatus: true,
        events: eid,
        users: '',
        hasCome: false,
        status: null,
        receipt_url: null,
        ticketID: Array.from({ length: 4 }, () =>
            'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'[Math.floor(Math.random() * 36)]
        ).join(''),
        visitedAt: null
    });
    const [allUsers, setallUsers] = useState([]);
    const [errors, setErrors] = useState({});
    const [customerrors, setCustomerrors] = useState({});
    const redirectHistory = useNavigate();
    const [loading, setLoading] = useState(true);
    const [alert, setAlert] = useState({ type: "", message: "" });

    const token = sessionStorage.getItem('JWT_TOKEN');


    //Get all users having the customer role.
    const fetchAllUsers = async () => {
        try {

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listallusers`, {
                params: {
                    roleType: "customer"
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }

            });

            const data = await response.data.data;            
            if (Array.isArray(data) && data.length > 0) {
                setallUsers(data);
            } else {
                setallUsers([]);
            }
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        document.documentElement.className = "";

        // Sirf admin ko allow karo
        if (role && role !== "admin") {
            redirectHistory(`/eventbookings/${eid}`);
            return;
        }
        fetchAllUsers();
    }, []);

    const validate = () => {
        const newErrors = {};
        if (!formData.users) newErrors.users = "User feild is required.";
        return newErrors;
    };

    if (formData.events !== eid) {
        const custErrors = {};
        custErrors.coupons = "Invalid Coupon.";
        setCustomerrors(custErrors);
    }

    const handleEventAdd = async (e) => {
        e.preventDefault();

        // Sirf admin ko allow karo
        if (role && role !== "admin") {
            redirectHistory(`/eventbookings/${eid}`);
            return;
        }
        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            try {
                //API URL
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/addeventbooking/${eid}`, {
                    paymentID: formData.paymentID,
                    paymentGateway: formData.paymentGateway,
                    paymentStatus: formData.paymentStatus,
                    events: formData.events,
                    users: formData.users,
                    hasCome: formData.hasCome,
                    status: formData.status,
                    receipt_url: formData.receipt_url,
                    ticketID: formData.ticketID,
                    visitedAt: formData.visitedAt
                },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token // Replace with your token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {
                    const redirectPath = `/eventbookings/${eid}`;
                    setAlert({ type: "success", message: "Event booking added successfully!" });
                    setTimeout(() => redirectHistory(redirectPath), 2500); // thoda delay deke redirect                         
                }

            } catch (err) {
                const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Failed to add event booking. Please try again");
                setAlert({ type: "error", message: apierror });
            }

        }
    }

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/events" className='btn btn-primary'>Events</Link></li>
                        <li><Link to={`/eventbookings/${eid}`} className='btn btn-primary'>Bookings</Link></li>
                        <li>Add</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Add booking {/* Add booking to {name} */}
                            </p>
                        </header>
                        <div className="card-content">
                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (
                                <form onSubmit={handleEventAdd}>
                                    {alert.message && (
                                        <AlertMessage
                                            type={alert.type}
                                            message={alert.message}
                                            onClose={() => setAlert({ type: "", message: "" })}
                                        />
                                    )}
                                    <input className="input" name="events" id="events" type="hidden" readOnly placeholder="Event" value={eid} />
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label" htmlFor="users">Select User <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <div className="select">
                                                    <select id="users" value={formData.users} onChange={e => setFormData({ ...formData, users: e.target.value })}>
                                                        <option value={''}>---Select---</option>
                                                        {allUsers.map((user, index) => (
                                                            <option value={user.$id}>{user.email}</option>
                                                        ))}
                                                    </select>
                                                    {errors.users && <p className="help" style={{ color: 'red' }}>{errors.users}</p>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div class="flex justify-center items-center">
                                            <div class="field grouped">
                                                <div class="control">
                                                    <button type="submit" class="button green">
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AddEventbooking;
